// @constants
const { INACTIVE_STATUS_LIST, CANCELLED_STATUS } = require('constants/contactCenter/cardStatus');

const existCancelledCards = (immCards) => {
    const immCardsByOrder = immCards.get('byOrder');
    const immCardsById = immCards.get('byId');

    return immCardsByOrder.filter((cardId) => {
        const immCard = immCardsById.get(cardId);
        const cardStatus = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');

        return INACTIVE_STATUS_LIST.includes(cardStatus);
    }).size > 0;
}

module.exports = {
    existCancelledCards
}